import React, { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Button } from '@chakra-ui/react';
import { BreadCrumbsItem } from '../../types';
import { Icon } from '../Icon/Icon';

interface BreadCrumbsProps {
	items: BreadCrumbsItem[];
}

export const BreadCrumbs = memo(({ items }: BreadCrumbsProps) => {
	const navigate = useNavigate();
	return (
		<Flex w="full" flexWrap="wrap">
			{items.map((item: BreadCrumbsItem, index: number) => {
				const isLast = index + 1 === items.length;
				return (
					<Flex key={index} mr={2} overflow="hidden">
						<Button
							variant="unstyled"
							color="inactiveText"
							rightIcon={
								!isLast ? (
									<Icon
										name="arrow-right"
										height={10}
										width={14}
										color="#7E788F"
									/>
								) : undefined
							}
							fontSize={16}
							textDecoration={isLast ? 'underline' : 'none'}
							onClick={() => {
								if (!item.route) {
									return;
								}
								navigate({
									pathname: item.route,
									...item.routeParams,
								});
							}}>
							{item.label}
						</Button>
					</Flex>
				);
			})}
		</Flex>
	);
});

BreadCrumbs.displayName = 'BreadCrumbs';
